<template>
  <div>
    <Table border :height="height" ref="table" :columns="innerColumns" :data="tableData" stripe size="large"
           @on-selection-change="selectionChange"></Table>
    <Page style="margin-top: 10px" :total="totalCount" show-elevator className="page" :current="page.pageIndex"
          :pageSize="page.pageSize" @on-change="changePageIndex" show-total></Page>
  </div>
</template>
<script>
  export default {
    name: 'List',
    props: {
      listUrl: {
        type: [String],
        default () {
          return ''
        }
      },
      params: {
        type: [Object],
        default () {
          return {}
        }
      },
      tableColumns: {
        type: Array,
        default () {
          return []
        }
      },
      reload: {
        type: Number,
        default () {
          return new Date().getTime()
        }
      },
      reloadWithPage: {
        type: Number,
        default () {
          return new Date().getTime()
        }
      },
      onLoading: {
        type: Function,
        default () {
          return null
        }
      },
      reset: {
        type: Boolean,
        default () {
          return false
        }
      },
      data: {
        type: Object,
        default () {
          return null
        }
      },
      uid: {
        type: Number,
        default () {
          return null
        }
      },
      height: null
    },
    data () {
      return {
        innerColumns: this.tableColumns,
        tableData: [],
        queryParam: {},
        totalCount: 0,
        page: {
          pageIndex: 1,
          pageSize: 10
        }
      }
    },
    mounted: function () {
    },
    methods: {
      search () {
        this.searchList('init')
      },
      searchList (type) {
        var self = this
        if (!this.listUrl) {
          return
        }
        if (type === 'init') {
          this.page.pageIndex = 1
        }
        this.queryParam = {}
        this.queryParam.uid = this.uid
        this.$helper.mergeProperties(this.params, this.queryParam)
        this.$helper.mergeProperties(this.page, this.queryParam)
        this.handleLoading(true)
        const loading = this.$Message.loading({
          content: '服务器疯狂处理中...',
          duration: 0
        })
        this.$http.post(this.listUrl, self.queryParam).then(function (res) {
          self.tableData = res.data.data
          self.totalCount = res.data.totalCount
          self.handleLoading(false)

          self.$router.replace({
            query: self.queryParam
          })
          loading()
        }).catch(function (e) {
          self.handleLoading(false)
          loading()
        })
      },
      changePageIndex (page) {
        this.page.pageIndex = page
        this.searchList()
      },
      handleLoading (loading) {
        if (this.onLoading) {
          this.onLoading(loading)
        }
      },
      selectionChange (selection) {
        this.$emit('on-selection-change', selection)
      }
    },
    watch: {
      params (val) {
        this.queryParam = val
      },
      reload (val) {
        if (val) {
          this.search()
        }
      },
      tableColumns (val) {
        this.innerColumns = val
      },
      reset (val) {
        this.tableData = []
      },
      data (val) {
        if (val) {
          this.tableData = val.data.data
          this.totalCount = val.data.totalCount
          this.page.pageIndex = val.data.pageIndex
        }
      },
      reloadWithPage (val) {
        if (val) {
          this.searchList('init')
        }
      }
    },
    created: function () {
      this.tableData = []
      let routeQuery = this.$route.query
      routeQuery.pageIndex && (this.page.pageIndex = parseInt(routeQuery.pageIndex))
      routeQuery.pageSize && (this.page.pageSize = parseInt(routeQuery.pageSize))
      delete routeQuery.pageIndex
      delete routeQuery.pageSize
      Object.assign(this.params, routeQuery)
    }
  }
</script>



// WEBPACK FOOTER //
// RecommendList.vue?0aec0d02